/* esm.sh - applesauce-core@5.2.0/promise */
function n(){let r,t,e=new Promise((o,c)=>{r=o,t=c});return e.resolve=r,e.reject=t,e}export{n as createDefer};
//# sourceMappingURL=promise.mjs.map